import React, { useEffect } from "react";
import "./Onboarding.css";
import "./Step1.css";

const FOOD_COURT_TENT_TYPE = "food_court";

const WFTO_TENT_TYPE = "WFTO"

const TWENTY_TWENTY_TYPE = "20x20_single"

const BIZ_BOOST ="biz_boost"

export default function Step1({ formData, setFormData, setCanProceed }) {
  const isFoodCourt = formData.tent_type === FOOD_COURT_TENT_TYPE;
  const isWfto = formData.tent_type === WFTO_TENT_TYPE;
  const istwenty = formData.tent_type === TWENTY_TWENTY_TYPE
  const isBizBoost =formData.tent_type === BIZ_BOOST

  const extrasList = [
    {
      name: "Hay Bales",
      type: "counter",
      description: "Hay Bales",
      price: 500,
    },
    {
      name: "Wristbands",
      type: "counter",
      description: "Additional Vendor Wristbands (valid through the weekend)",
      price: 300,
    },
    {
      name: "Single Socket",
      type: "toggle",
      description: "Dedicated power connection",
      price: 3480,
      includedFor: isFoodCourt || istwenty || isWfto
    },
  ];

  const updateExtra = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      extras: { ...prev.extras, [name]: value },
    }));
  };

  // Pre-check the socket for food court vendors
  useEffect(() => {
    if (isFoodCourt && !formData.extras?.["Single Socket"]) {
      setFormData((prev) => ({
        ...prev,
        extras: { ...prev.extras, "Single Socket": true },
      }));
    }
  }, [isFoodCourt]);

  useEffect(()=>{
    if (isWfto && !formData.extras?.["Single Socket"]){
      setFormData((prev) =>({
        ...prev,
        extras: { ...prev.extras, "Single Socket": true},
        
      }))
    }

  })

  useEffect(() => {
    setCanProceed(!!formData.agreed);
  }, [formData.agreed, setCanProceed]);

  return (
    <div className="onboarding-step">
      <h3>
        Step 1: Optional Add-Ons{" "}
        <span style={{ fontSize: "10px" }}>(Incl of VAT)</span>
      </h3>

      {/* Extras */}
      <div className="card-section">
        <div className="extras-grid">
          {extrasList.map((extra) => (
            <div
              key={extra.name}
              className={`extra-card ${extra.includedFor ? "extra-card--included" : ""}`}
            >
              <div>
                <h5>{extra.name}</h5>
                <p>{extra.description}</p>
                {extra.includedFor ? (
                  <span className="extra-price extra-price--included">
                    Included in your package
                  </span>
                ) : (
                  <span className="extra-price">
                    KES {extra.price.toLocaleString()}
                  </span>
                )}
              </div>

              {extra.type === "counter" && (
                <div className="counter">
                  <button
                    onClick={() =>
                      updateExtra(
                        extra.name,
                        Math.max(0, (formData.extras?.[extra.name] || 0) - 1)
                      )
                    }
                  >
                    −
                  </button>
                  <span>{formData.extras?.[extra.name] || 0}</span>
                  <button
                    onClick={() =>
                      updateExtra(
                        extra.name,
                        (formData.extras?.[extra.name] || 0) + 1
                      )
                    }
                  >
                    +
                  </button>
                </div>
              )}

              {extra.type === "toggle" && (
                <input
                  type="checkbox"
                  checked={extra.includedFor ? true : !!formData.extras?.[extra.name]}
                  disabled={extra.includedFor}
                  onChange={(e) =>
                    !extra.includedFor && updateExtra(extra.name, e.target.checked)
                  }
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Terms */}
      <div className="terms-section">
        <label>
          <input
            type="checkbox"
            checked={formData.agreed || false}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                agreed: e.target.checked,
              }))
            }
            required
          />
          I confirm that I have read and agree to the{" "}
          <span>
            <a
              href="https://www.bizbazevents.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </span>
        </label>
      </div>
    </div>
  );
}